import React, { useMemo, useState } from "react";
import { useSelector } from "react-redux";

import { metronic } from "../../../_metronic";


import CalendarEvents from "../../widgets/CalendarEvents";
import Banner from "../../widgets/Banner";


import { getMenus } from "../../crud/auth.crud";


export default function Dashboard() {

  const [permissions,setPermissions] =useState({permission:''});
  
  React.useEffect(() => {
        const fetchPermissions = async () => {
            try {
                //setPermissions({roles: rolesData.roles, isLoading: true});
                const response = await getMenus()
                if(response.data[0] != null && response.data[0].permissions !=null)
                {
                 
                  //console.log(response.data[0].permissions);
                  let perms="";
                  response.data[0].permissions.map((per) =>(
                    perms = perms + "," + per
                    ))
                  //console.log(perms);
                   setPermissions({permission: perms});

                }
            } catch (e) {
                //console.log(e);
                //setPermissions({roles: rolesData.roles, isLoading: false});
            }
        };
        fetchPermissions();
    }, []);




  const { brandColor, dangerColor, successColor, primaryColor } = useSelector(
    state => ({
      brandColor: metronic.builder.selectors.getConfig(
        state,
        "colors.state.brand"
      ),
      dangerColor: metronic.builder.selectors.getConfig(
        state,
        "colors.state.danger"
      ),
      successColor: metronic.builder.selectors.getConfig(
        state,
        "colors.state.success"
      ),
      primaryColor: metronic.builder.selectors.getConfig(
        state,
        "colors.state.primary"
      )
    })
  );

  const chartOptions = useMemo(
    () => ({
      chart1: {
        data: [10, 14, 18, 11, 9, 12, 14, 17, 18, 14],
        color: brandColor,
        border: 3
      },

      chart2: {
        data: [11, 12, 18, 13, 11, 12, 15, 13, 19, 15],
        color: dangerColor,
        border: 3
      },

      chart3: {
        data: [12, 12, 18, 11, 15, 12, 13, 16, 11, 18],
        color: successColor,
        border: 3
      },

      chart4: {
        data: [11, 9, 13, 18, 13, 15, 14, 13, 18, 15],
        color: primaryColor,
        border: 3
      }
    }),
    [brandColor, dangerColor, primaryColor, successColor]
  );

  return (

    <>
        <Banner/>

       {(permissions.permission.includes("WIDGETCALENDAR") &&
      
          <CalendarEvents  />
     
      )}
    </>
  );
}
